export default checkedDesc => ({ form }) => ({
	form: {
		...form,
		overview: {
			value: checkedDesc,
			error: { isError: false, message: "" }
		}
	}
});